export default __webpack_public_path__ + "static/media/ic-email.b57675e7.svg";